//****************** GUDHUB HTTPS SERVICE ***********************//
//-- This Service decorates each POST and GET request with Token
//-- This Service take care of toking beeing always valid

import axios from "axios";
import { convertObjToUrlParams } from "./utils.js";
import qs from "qs";
export class GudHubHttpsService {
  constructor(server_url) {
    this.root = server_url;
    this.requestPromises = []; 
  }


  //****************** INITIALISATION **************//
  // Here we set a function to get token
  init(getToken) {
    this.getToken = getToken;
  }

  
   //********************* GET ***********************//
   async get(request) {
    const accessToken = await this.getToken();
    const hesh = this.getHashCode(request);


    if (this.requestPromises[hesh]) {
      return this.requestPromises[hesh].promise;
    }

     const promise = new Promise((resolve, reject) => {
      let url;
      if(request.externalResource) {
        url = request.url;
      } else {
        url = this.root + request.url;
        url = `${url}${
         /\?/.test(url) ? "&" : "?"
       }token=${accessToken}${convertObjToUrlParams(request.params)}`;
      }
      axios.get(url, {
        validateStatus: function (status) {
            return status < 400; // Resolve only if the status code is less than 400
        }
      }).then(function (response) {
        if(response.status != 200) {
          console.error(`GUDHUB HTTP SERVICE: GET ERROR: ${response.status}`, response);
        }
        // handle success
        resolve(response.data);
      })
      .catch(function (err) {
        console.error(`GUDHUB HTTP SERVICE: GET ERROR: ${err.response.status}\n`, err);
        console.log("Request message: ", request);
        if(err.response && err.response.data) {
          console.log('Error response data: ', err.response.data);
        }
        reject(err);
      });

    });
     
    this.pushPromise(promise, hesh);

    return promise;
  }

  //********************* POST ***********************//
  async post(request) {
    const hesh = this.getHashCode(request);
    request.form["token"] = await this.getToken();


    if (this.requestPromises[hesh]) {
      return this.requestPromises[hesh].promise;
    }

    const promise = new Promise((resolve, reject) => {
      axios.post(
        this.root + request.url,
        qs.stringify(request.form),
        {
          maxBodyLength: Infinity,
          headers: request.headers || {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          validateStatus: function (status) {
            return status < 400; // Resolve only if the status code is less than 400
          }
        }
      ).then(function (response) {
        if(response.status != 200) {
          console.error(`GUDHUB HTTP SERVICE: POST ERROR: ${response.status}`, response);
        }
        // handle success
        resolve(response.data);
      }).catch(function (error) {
        console.error(`GUDHUB HTTP SERVICE: POST ERROR: ${error.response.status}\n`, error);
        console.log("Request message: ", request);
        reject(error);
      });
    });
    
    this.pushPromise(promise, hesh);

    return promise;
  }

  /*************** AXIOS REQUEST ***************/
  // It's using to send simple requests to custom urls without token
  // If you want to send application/x-www-form-urlencoded, pass data in 'form' property of request
  // If you wnt to send any other type of data, just pass it to 'body' property of request

  axiosRequest(request) {
    const hesh = this.getHashCode(request);

    if (this.requestPromises[hesh]) {
      return this.requestPromises[hesh].promise;
    }

    let method = request.method ? request.method.toLowerCase() : 'get';
    let url = request.url;
    let headers = request.headers || {};
    if(request.form) {
      headers['Content-Type'] = 'application/x-www-form-urlencoded';
    }

    const promise = new Promise(async (resolve, reject) => {
      try {
        const { data } = await axios[method](url, method === 'post' ? (qs.stringify(request.form) || request.body) : { headers }, method === 'post' ? {
          headers
        } : {});
        resolve(data);
      } catch(error) {
        console.log("ERROR -> GUDHUB HTTP SERVICE -> SIMPLE POST :", error.message);
        console.log("Request message: ", request);
        reject(error);
      }
    });

    this.pushPromise(promise, hesh);

    return promise;
  }

  /*************** PUSH PROMISE ***************/
  // It push promise object by hash to this.requestPromises

  pushPromise(promise, hesh) {
    this.requestPromises[hesh] = {
      promise,
      hesh,
      callback: promise.then(() => {
        this.destroyPromise(hesh);
      }).catch(err => {
        this.destroyPromise(hesh);
      })
    }
  }

  /*************** DELETE PROMISE ***************/
  // It deletes promise from this.requestPromises by hash after promise resolve

  destroyPromise(hesh) {
    this.requestPromises = this.requestPromises.filter(request => request.hesh !== hesh)
  }


  //********************* GET HASH CODE ***********************//
  // it generates numeric identificator whish is the same for similar requests
  // HASH CODE is generated based on: request.params, request.url, request.form
  getHashCode(request){
    let hash = 0;
    let str = qs.stringify(request)
    if (str.length == 0) return hash;

    for (let i = 0; i < str.length; i++) {
      let char = str.charCodeAt(i);
      hash = ((hash<<5)-hash)+char;
      hash = hash & hash; // Convert to 32bit integer
    }
    return "h" + hash;
  }
}
